import dynamic from 'next/dynamic';
import { AutoPlayProvider } from 'src/context/AutoPlayContext';

const ChooseLanguage = dynamic(import('./../ChooseLanguage'), {
  ssr: false,
});
const SignUp = dynamic(import(/* webpackChunkName: "SignUp" */ './../SignUp'), {
  ssr: false,
});

interface BienvenueRouterProps {
  nextUrl?: string;
  sourceLanguage?: string;
  targetLanguage?: string;
  languagePairId?: number;
}

const BienvenueRouter = ({
  sourceLanguage,
  targetLanguage,
  languagePairId,
  nextUrl,
}: BienvenueRouterProps) => {
  if (sourceLanguage && targetLanguage) {
    return (
      <SignUp
        sourceLanguage={sourceLanguage}
        targetLanguage={targetLanguage}
        languagePairId={languagePairId}
        nextUrl={nextUrl}
      />
    );
  }
  return (
    <AutoPlayProvider>
      <ChooseLanguage nextUrl={nextUrl} />
    </AutoPlayProvider>
  );
};

export default BienvenueRouter;
